var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpenRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264-168h432v-384H264v384Zm216.212-120Q510-288 531-309.212q21-21.213 21-51Q552-390 530.788-411q-21.213-21-51-21Q450-432 429-410.788q-21 21.213-21 51Q408-330 429.212-309q21.213 21 51 21ZM264-168v-384 384Zm-.283 72Q234-96 213-117.15T192-168v-384q0-29.7 21.15-50.85Q234.3-624 264-624h264v-96q0-79.68 56.226-135.84t136-56.16Q800-912 856-855.84T912-720h-72q0-50-35-85t-85-35q-50 0-85 35t-35 85v96h96q29.7 0 50.85 21.15Q768-581.7 768-552v384q0 29.7-21.162 50.85Q725.676-96 695.96-96H263.717Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenRight);
export default __webpack_public_path__ + "static/media/lock_open_right.77cc263cc44a728d96b0075d052e35c5.svg";
export { ForwardRef as ReactComponent };